import axios from "axios";

export const fetcherSWR = async (url: string, showError = false, body: any) => {
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.accessToken}`,
      Accept: "application/json"
    }
  };
  if (typeof window !== "undefined") {
    if (localStorage.accessToken && options.headers) {
      options.headers["Authorization"] = `bearer ${localStorage.accessToken}`;
    }
  }

  // eslint-disable-next-line no-undef
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  let response: any = null;
  try {
    response = await fetch(baseUrl + url, options);
    const json = await response.json();
    if (response.ok) {
      return json;
    }
    if (response.status === "404") {
      throw new Error("Not Found");
    }
    if (response.status === "400") {
      throw new Error("Bad Request");
    }
    if (response.status === "500") {
      throw new Error(
        "Server Error, Please try again later or contact support"
      );
    }
    // showError && toast.error(json.messages);
    throw new Error(json.messages);
  } catch (e: any) {
    // showError && toast.error(e.message || e.stack);
    throw new Error(e.message || e.stack);
  }
};

const fetcher = async (
  url: string | number,
  showError: boolean,
  method: any = "GET",
  body?: any
) => {
  const options: any = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `bearer ${localStorage.businessAccessToken}`
    }
  };

  if (body !== undefined && method !== "GET") {
    options.body = JSON.stringify(body);
  }

  // eslint-disable-next-line no-undef
  const baseUrl: string = process.env.REACT_APP_API_BASE_URL || "";

  try {
    const response: any = await fetch(baseUrl + url, options);
    const json =
      (await response.status) === 204 ? null : await response?.json();
    if (response.ok || response.status === 204) {
      return { data: json || [] };
    }
    if (response.status === "404") {
      throw new Error("Not Found");
    }
    if (response.status === "400") {
      throw new Error("Bad Request");
    }
    if (response.status === "500") {
      throw new Error(
        "Server Error, Please try again later or contact support"
      );
    }
  } catch (e: any) {
    throw showError && new Error(e.message || e.stack);
  }
};

const api = {
  get(url: string | number, showError = false) {
    return fetcher(url, showError);
  },
  post(url: string | number, data?: any, showError = true) {
    return fetcher(url, showError, "POST", data);
  },
  put(url: string | number, data: any, showError = true) {
    // Use axios for order update endpoint
    if (typeof url === "string" && url.includes("/ordering/console/order/")) {
      const token = localStorage.businessAccessToken;
      return axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${token}`
        },
        data: JSON.stringify(data)
      })
        .then((response: { data: any }) => ({ data: response.data }))
        .catch((error: unknown) => {
          throw error;
        });
    }
    // Default to fetcher for other PUT requests
    return fetcher(url, showError, "PUT", data);
  },
  delete(url: string | number, data: any, showError = true) {
    return fetcher(url, showError, "DELETE", data);
  },
  postFormData(url: string | number, formData: any, showError = true) {
    return fetcher(url, showError, "POST", formData);
  }
};

// Order Console API endpoints - Updated for new API Gateway
export const orderConsoleApi = {
  // 1. Initialization: Get status settings
  init: (businessId: string) => `/ordering/console/init/${businessId}`,

  // 2. Order Display: Fetch orders (called every 20 seconds)
  display: (businessId: string) =>
    `/ordering/console/ordersinprogress/${businessId}`,

  // 3. Status Updates: Move orders through workflow
  updateStatus: (businessId: string) => `/ordering/console/order/${businessId}`,

  // 4. Heartbeat: Keep console alive (every 2 cycles)
  heartbeat: (businessId: string) =>
    `/ordering/console/heartbeat/${businessId}`,

  // 5. Login/Logout (implemented with portal auth system)
  logout: () => "/auth/logout"
};

// Merchant API endpoints
export const merchantApi = {
  getBusinesses: () =>
    `${process.env.REACT_APP_API_BASE_URL}/datacollectionbusiness/businesses`
};

// Function to fetch merchant information
export const fetchMerchantInfo = async (accessToken: string) => {
  try {
    const response = await fetch(merchantApi.getBusinesses(), {
      method: "GET",
      headers: {
        Authorization: `bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching merchant info:", error);
    throw error;
  }
};

export default api;
